// extracted by mini-css-extract-plugin
export default {"container":"simulation_container__apvX7","divider":"simulation_divider__GV92U"};